import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetCategoryAttributesResponse } from '@/api/handlers/resources/categories/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { CategoryQueryKeys } from './categoryQueryKeys';

/**
 * The attribute set a category subscribes to (Surface A). Disabled unless a
 * real category id is present — an empty/whitespace id (e.g. a bare
 * `?attributes=` deep-link) is treated as closed, so the request only ever
 * fires for the category the user is actually managing (never `/categories//…`).
 */
export const useCategoryAttributesQuery = (categoryId: string | null) => {
    const { apiClient } = useApi();
    const id = categoryId?.trim() ? categoryId : null;

    return useQuery<ApiResponse<GetCategoryAttributesResponse>>({
        queryKey: CategoryQueryKeys.attributes(id ?? ''),
        queryFn: () => apiClient.categories.getCategoryAttributes(id ?? ''),
        enabled: id !== null,
        staleTime: 60_000,
    });
};
